import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollAnimationDirective } from '../../directives/scroll-animation.directive';
import { CERTIFICATIONS } from '../../data/certifications.data';
import { CertificationCardComponent } from './certification-card.component';
import { MotionBackgroundComponent } from '../shared/motion-background.component';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-certifications',
  standalone: true,
  imports: [
    CommonModule,
    CertificationCardComponent,
    ScrollAnimationDirective,
    MotionBackgroundComponent,
    TranslateModule
  ],
  template: `
    <section id="certifications" class="section certification-section">
      <app-motion-background></app-motion-background>
      <div class="container">
        <h2 class="section-title text-center">{{ translatedTitle }}</h2>
        <div class="certification-grid">
          <app-certification-card 
            *ngFor="let cert of certifications" 
            [certification]="cert">
          </app-certification-card>
        </div>
      </div>
    </section>
  `,
  styles: [`
    .certification-section {
      background: #6a1b9a;
      color: white;
      padding: 4rem 0;
      position: relative;
      overflow: hidden;
    }

    .certification-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 2rem;
      margin: 3rem 0;
      max-width: 1000px;
      margin-left: auto;
      margin-right: auto;
      position: relative;
      z-index: 1;
    }

    @media (max-width: 768px) {
      .certification-grid {
        grid-template-columns: 1fr;
      }
    }
  `]
})
export class CertificationsComponent implements OnInit {
  certifications = CERTIFICATIONS;
  translatedTitle: string;

  constructor(public _translate: TranslateService) {}

  ngOnInit(): void {
    this.translatedTitle = this._translate.instant('CERTIFICATIONS.TITLE');
  }
}
